import Request from 'gd-request';

class ApiTaskTable {

    constructor() {}

}


module.exports = ApiTaskTable;